export enum LinkType {
	Backward = 0,
	Forward = 1,
	Restart = 2
}